import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectMaintenanceMessage } from '@qvs/core/remoteConfig';
import { SplashScreen } from '@capacitor/splash-screen';
import { CommonModule } from '@angular/common';
import { IonicModule, Platform } from '@ionic/angular';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AssetByColorModePipe } from '~/shared/pipes/asset-by-color-mode.pipe';

@Component({
  selector: 'qvs-maintenance',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslatePipe, AssetByColorModePipe],
  templateUrl: './maintenance.page.html',
  styleUrls: ['./maintenance.page.scss']
})
export class MaintenancePage implements OnInit {
  maintenanceMessage$: Observable<string>;
  readonly logo = { light: 'assets/Logo_EFG.svg', dark: 'assets/Logo_EFG-dark.svg' };
  readonly mobileImage = { light: 'assets/images/maintenance.svg', dark: 'assets/images/maintenance-dark.svg' };
  readonly desktopImage = { light: 'assets/maintenance-desktop.svg', dark: 'assets/maintenance-desktop-dark.svg' };

  constructor(private readonly store: Store, private readonly platform: Platform, private readonly translateService: TranslateService) {
    this.maintenanceMessage$ = this.store.pipe(select(selectMaintenanceMessage));
  }

  ngOnInit() {
    SplashScreen.hide();
  }

  get contactLink(): string {
    return this.platform.is('hybrid') ?
      `tel:${this.translateService.instant('maintenance.PHONE')}`
      : `mailto:${this.translateService.instant('maintenance.EMAIL')}`;
  }
}
